<div class="head_wrapper">
    <h1 class="team_head">Our Team</h1>
</div>
<div class="container">
    <div class="row justify-content-center" style="margin: auto;">  
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 team_wrapper ">
            <img src="../../assets/images/Team photo/sanjay.jpg"class="team_img">
            <div style="padding: 8px;">
                <h1 class="team_name">Sanjay Singh</h1>
                <p class="team_designation">COO</p>
            </div>
        </div>      
         
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 team_wrapper ">
            <img src="../../assets/images/Team photo/sahdev.jpg" class="team_img">
            <div style="padding: 8px;">
                <h1 class="team_name">Sahdev Patawat </h1>
                <p class="team_designation">Operations</p>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 team_wrapper ">
            <img src="../../assets/images/Team photo/PrabhatKumar.webp" class="team_img">
            <div style="padding: 8px;">
                <h1 class="team_name">Prabhat Kumar</h1>
                <p class="team_designation">CEO</p>
            </div>
        </div>  
        
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 team_wrapper ">
            <img src="../../assets/images/Team photo/rohanv.jpg" class="team_img">
            <div style="padding: 8px;">
                <h1 class="team_name">Rohan Vaish</h1>
                <p class="team_designation">Technology</p>
            </div>
        </div>
        <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 team_wrapper ">
            <img src="../../assets/images/Team photo/ravichintal.jpg" class="team_img">
            <div style="padding: 8px;">
                <h1 class="team_name">Ravi Chintal</h1>
                <p class="team_designation">Acquition & Sales</p>
            </div>
        </div> -->
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 team_wrapper ">
            <img src="../../assets/images/Team photo/syed_v.jpeg" class="team_img">
            <div style="padding: 8px;">
                <h1 class="team_name">Syed Vikhas</h1>
                <p class="team_designation">Sales</p>
            </div>
        </div> 
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 team_wrapper ">
            <img src="../../assets/images/Team photo/anish.jpg" class="team_img">
            <div style="padding: 8px;">
                <h1 class="team_name">Anish Rahman</h1>
                <p class="team_designation">Vendor Manager & Operations</p>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 team_wrapper ">
            <img src="../../assets/images/Team photo/santosh.jpeg" class="team_img">
            <div style="padding: 8px;">
                <h1 class="team_name">Santosh Sankalp</h1>
                <p class="team_designation">Operations</p>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 team_wrapper ">
            <img src="../../assets/images/Team photo/jyoti.jpg" class="team_img">
            <div style="padding: 8px;">
                <h1 class="team_name">Jyoti Pathak</h1>
                <p class="team_designation">PMO </p>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 team_wrapper ">
            <img src="../../assets/images/Team photo/shubojeet.jpg" class="team_img">
            <div style="padding: 8px;">
                <h1 class="team_name"> Shubojeet </h1>
                <p class="team_designation"> Customer Support </p>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 team_wrapper ">
            <img src="../../assets/images/Team photo/pramod.png" class="team_img">
            <div style="padding: 8px;">
                <h1 class="team_name">Pramod Walunj</h1>
                <p class="team_designation">Operations</p>
            </div>
        </div> 
        
    </div>
</div>